import React, { useState, useEffect } from "react";
import "../Styles/Show.css";
import config from "../../config/Config";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function Blogcategory({ hideSidebar }) {
  const [data, setData] = useState([]);
  const [showTitles, setShowTitles] = useState(false);

  function demo() {
    fetch(`${config.API_BLOG}get_category`).then((result) => {
      result.json().then((res) => {
        setData(res);
      });
    });
  }

  useEffect(() => {
    demo();
  }, []);

  const toggleTitles = () => {
    setShowTitles(!showTitles);
  };

  const toSlug = (text) => {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <span
          style={{ color: "white", cursor: "pointer" }}
          onClick={toggleTitles}
        >
          <span className="ms-3 heading_font" style={{ fontSize: "18px" }}>
            Blog Category
          </span>
        </span>
        {showTitles && (
          <div>
            <ul
              className="lesson-list"
              style={{
                listStyleType: "disc",
                paddingLeft: "20px",
                color: "white",
              }}
            >
              {data
                .filter((item) => item.posts_count > 0)
                .map((item) => (
                  <li key={item.category_id} className="card-body ms-3 fs-6">
                    <Helmet>
                      <meta name="title" content={`${item.meta_title}`} />
                      <meta
                        name="description"
                        content={`${item.meta_description}`}
                      />
                      <meta name="keywords" content={`${item.meta_keywords}`} />
                    </Helmet>
                    <Link
                      style={{
                        textDecoration: "none",
                        color: "white",
                        fontSize: "14px",
                      }}
                      to={`/blog/category/${toSlug(item.category_name)}`}
                      state={{ item }}
                      onClick={hideSidebar}
                      className="para_font_family"
                    >
                      {item.category_name} ({item.posts_count})
                    </Link>
                  </li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
